import {ApiURL, IntlMessageValue} from "../../../../core/Elements/index";
// @ts-ignore
import { Notification } from 'create-notifications/notfication'
import Button from "react-bootstrap/Button";
import React from "react";
import Form from 'react-bootstrap/Form'
const ForgottPassword = (props: { value: any }) => {
    const [showSuccessMessage, setShowSuccessMessage] = React.useState<boolean>(false);
    const send = (e: any) => {
        e.preventDefault()
        let data = new FormData(e.target)
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        let value = Object.fromEntries(data.entries())
        let raw = JSON.stringify(value)
        let root = ApiURL()
        let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw
        };

        fetch(root + 'user/passwort-reset/', requestOptions)
            .then((response) => response.text())
            .then((result) => afterSend('success'))
            .catch((error) => afterSend('error'))
    }
    const afterSend = (state: any) => {
        if (state === 'success') {
            setShowSuccessMessage(true);
            Notification({
                reload: false,
                type: 'success',
                mode: 'classic',
                title: { text: 'Success' },
                text: { text: 'E-Mail erfolgreich versendet' },
                insert: 'center right',
                duration: 4
            })
        } else if (state === 'error') {
            Notification({
                reload: true,
                type: 'danger',
                mode: 'classic',
                title: { text: 'Error' },
                text: { text: 'Sorry, an error has occurred' },
                insert: 'center right',
                duration: 4
            })
        }
    }

    return(

        <div className="card text-center " style={{width:'300px',paddingBottom: '2em',margin: '0 auto',marginTop: '10%'}} >
            <Form onSubmit={(e) => send(e)}>
            <div className="card-header h5 text-white " style={{backgroundColor: 'rgb(0, 98, 204)', borderColor: '#005cbf '}}>{IntlMessageValue("","common.password.reset","")}</div>
            <div className="card-body px-5">
                <p className="card-text py-2">
                    {IntlMessageValue("","common.password.reset.text","")}
                </p>
                <div className="form-outline">
                    <input type="email" id="typeEmail" name={'email'} className="form-control my-3" placeholder={IntlMessageValue("","max@mustermann.de","")}/>
                </div>
                {process.env.REACT_APP_Register !== undefined ? (
                    <>
                        <Button variant="success" type="submit">
                            {IntlMessageValue("","common.password.reset.button","")}
                        </Button>
                    <div className="d-flex justify-content-between mt-4">
                        <a className="btn btn-secondary" href="/">Login</a>
                        <a className="btn btn-secondary" href="/Signin">Register</a>
                    </div>
                    </>
                ) : (
                    <>


                    <Button variant="success" className={'w100 mb-3'} type="submit">
                        {IntlMessageValue("","common.password.reset.button","")}
                    </Button>
                    <a className="btn btn-secondary w100 mb-3" href="/">Login</a>

                    </>
                )}
            </div>
        </Form>
            {showSuccessMessage && (
                <div className="alert alert-success m-3" role="alert">
                    {IntlMessageValue("","common.password.reset.notification","")}
                </div>
            )}
        </div>

    )
}

export default ForgottPassword;
